import { finish, error } from '../../../modules/fraud-and-compliance/actions/update';
import api from '../../../api';

export function request(dispatch, { entity, action, id }) {
    api.post('/fraud-and-compliance/' + entity + '/' + action + '/' + id).then(
        () => dispatch(finish(id, action)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
